module.exports = __webpack_public_path__ + "media/format-selector/online_event@2x-c4f06aae.png";